export const TAB_KEYS = {
  details: "workflowtask",
  notes: "notes",
};

export const DEFAULT_TAB_KEY = TAB_KEYS.details;
